import React, { useState } from "react";

const FlowSelector = ({ 
  flows, 
  activeFlowId, 
  onFlowChange, 
  onCreateFlow 
}) => {
  const [showModal, setShowModal] = useState(false);
  const [newFlowName, setNewFlowName] = useState('');

  const handleCreateClick = () => {
    setShowModal(true);
    setNewFlowName('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newFlowName.trim()) {
      onCreateFlow(newFlowName.trim());
      setShowModal(false);
      setNewFlowName('');
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setNewFlowName('');
  };

  return (
    <div className="flow-selector">
      <div className="flow-selector-header">
        <span className="flow-label">Flows</span>
        <button 
          className="flow-add-btn" 
          onClick={handleCreateClick}
          title="Create new flow"
        >
          +
        </button>
      </div>
      
      <div className="flow-pills">
        {flows.map(flow => (
          <button
            key={flow.id}
            className={`flow-pill ${activeFlowId === flow.id ? 'active' : ''}`}
            onClick={() => onFlowChange(flow.id)}
          >
            {flow.name}
          </button>
        ))}
      </div>

      {showModal && (
        <div className="flow-modal-overlay" onClick={handleCancel}>
          <div className="flow-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Enter Flow Name</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                value={newFlowName}
                onChange={(e) => setNewFlowName(e.target.value)}
                placeholder="Flow name..."
                autoFocus
                maxLength={30}
              />
              <div className="flow-modal-buttons">
                <button type="button" onClick={handleCancel}>
                  Cancel
                </button>
                <button type="submit" disabled={!newFlowName.trim()}>
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FlowSelector;
